import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { APIDocsPage } from "./api-docs";
import { FlxCommonsModule } from "@questrade/flx-commons";
import { DevBreadcrumbsComponentModule } from '../../components/dev-breadcrumbs/dev-breadcrumbs.module';
import { DevJumbotronComponentModule } from '../../components/dev-jumbotron/dev-jumbotron.module';

@NgModule({
  declarations: [
    APIDocsPage
  ],
  imports: [
    DevBreadcrumbsComponentModule,
    DevJumbotronComponentModule,
    FlxCommonsModule,
    IonicPageModule.forChild(APIDocsPage)
  ],
  exports: [
    APIDocsPage
  ]
})
export class APIDocsPagePageModule { }



// WEBPACK FOOTER //
// ./src/pages/api-docs/api-docs.module.ts